import Cookies from "js-cookie"
import { MOJO_COOKIE_URL } from "../Config"

export const readCookie = (key: string): string | undefined =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${key}=`))
    ?.split("=")[1]

export const setCookie = (
  key: string,
  value: string,
  expirySeconds = 31556926 // one year
) => {
  const now = new Date()
  const ms = expirySeconds * 1000
  const expireTime = new Date(now.getTime() + ms)
  document.cookie = `${key}=${value}; expires=${expireTime.toUTCString()}; domain=${MOJO_COOKIE_URL}`
}

export function GetCookie(cookieName: string): string | null {
  return Cookies.get(cookieName)
}

export enum DevModeScenario {
  Advise = "Advise",
  Booked = "Booked",
  Offer = "Offer",
  RecommendationPending = "RecommendationPending",
  RecommendationReady = "RecommendationReady",
  RecommendationAccepted = "RecommendationAccepted",
  RecommendationAcceptedDocsRequired = "RecommendationAcceptedDocsRequired",
  Application = "Application",
  Won = "Won",
  CompletionSet = "CompletionSet",
  Dip = "Dip",
  Lost = "Lost",
  Wip = "Wip",
  OfferAccepted = "OfferAccepted",
  OfferAcceptedBooked = "OfferAcceptedBooked",
  Core = "Core",
  BTLSpecialistPayment = "BTLSpecialistPayment",
  PrepareForAppointment = "PrepareForAppointment",
  PrepareForAppointmentDocsOnly = "PrepareForAppointmentDocsOnly",
}

export function isDevModeEnabled(): boolean {
  const cookieValue = GetCookie("dev-mode")
  return (
    cookieValue !== null && Object.values(DevModeScenario).includes(cookieValue as DevModeScenario)
  )
}

export function getDevModeScenario(): DevModeScenario | null {
  const cookieValue = GetCookie("dev-mode")

  if (!cookieValue) {
    return null
  }

  if (Object.values(DevModeScenario).includes(cookieValue as DevModeScenario)) {
    return cookieValue as DevModeScenario
  }

  const validOptions = Object.values(DevModeScenario).join(", ")
  console.error(`Invalid dev-mode value: '${cookieValue}'. Valid options: ${validOptions}`)
  return null
}

// Enable/disable dev mode
export function enableDevMode(scenario: DevModeScenario = DevModeScenario.Advise): void {
  SetCookie("dev-mode", scenario)
  console.log(`🔧 Dev mode: Enabled with scenario '${scenario}'`)
}

export function disableDevMode(): void {
  DeleteCookie("dev-mode")
  console.log("🔧 Dev mode: Disabled")
}
export function SetCookie(cookieName: string, value: string, lifetimeSeconds: number = null) {
  const cookieConf = { expires: null, domain: null }

  if (lifetimeSeconds) {
    cookieConf.expires = lifetimeSeconds / 86400
  }

  cookieConf.domain = MOJO_COOKIE_URL

  try {
    Cookies.set(cookieName, value, cookieConf)
  } catch (e) {
    console.log(e)
  }
}

export function DeleteCookie(cookieName: string) {
  Cookies.remove(cookieName, { path: "", domain: MOJO_COOKIE_URL })
}
